import React, { useCallback, useEffect, useState } from 'react'
import Router from './routing/Router'
import './AppSecurity'
import 'react-app-polyfill/ie11'
import { useDispatch, useSelector } from 'react-redux'
import { getErrorMessageSelector } from './selectors/error.selector'
import { setErrorMessage } from './actions/error.actions'
import Modal from './components/Modal/Modal'
import NeoButton from './components/NeoButton/NeoButton'
import { useModal } from 'react-modal-hook'
import { DEFAULT_ERROR_KEYS } from './utils/translation-constants'
import { useTranslation } from 'react-i18next'
import { setAppLanguage } from './actions'
import i18next from 'i18next'

export default function App() {
  const errors = useSelector(getErrorMessageSelector)
  const dispatch = useDispatch()
  const [error, setError] = useState({})
  const { t } = useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code || t(DEFAULT_ERROR_KEYS.DEFAULT_ERROR_CODE)}</b> : {error?.message || t(DEFAULT_ERROR_KEYS.DEFAULT_ERROR_MESSAGE)}
          </h6>
          {error?.errors && (
            <>
              <p>{t(DEFAULT_ERROR_KEYS.DEFAULT_ERROR_HEADER)}</p>
              <ul>
                {error?.errors.map((option, index) => (
                  <li key={index}>{option}</li>
                ))}
              </ul>
            </>
          )}
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={'Ok'}
              onClick={() => {
                hideModal()
                dispatch(setErrorMessage(null))
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    dispatch(setAppLanguage('EN'))
    i18next.changeLanguage('EN')
  }, [])



  useEffect(() => {
    showErrors()
  }, [errors])

  const showErrors = useCallback(() => {
    try {
      if (errors) {
        if ((errors.status === 400 || errors.status === 0) && !errors?.data) {
          setError({
            code: t(DEFAULT_ERROR_KEYS.DEFAULT_ERROR_CODE),
            message: t(DEFAULT_ERROR_KEYS.DEFAULT_ERROR_MESSAGE),
            errors: null,
          })
        } else {
          setError(errors?.data)
        }
        showModal()
      }
    } catch (err) { }
  }, [errors])

  return (
    <>
      <Router />
    </>
  )
}
